const CREATE_ORGANIZATION_DRAWER = {
  TITLE: 'Crear organización',
  ACTIONS: {
    CANCEL: 'Cancelar',
    CREATE: 'Crear',
    CREATING: 'Creando...',
  },
  FIELDS: {
    NAME: {
      LABEL: 'Nombre *',
      PLACEHOLDER: 'Acme, Inc.',
    },
    DOMAINS: {
      LABEL: 'Dominios (opcional)',
      PLACEHOLDER: 'acme.com',
      ADD: 'Agregar',
      PRIMARY_LABEL: 'Dominio principal (opcional)',
      NO_PRIMARY: 'Sin dominio principal',
      EMPTY_TEXT: 'Aún no se agregaron dominios.',
      REMOVE: 'Eliminar dominio',
    },
    LANGUAGE: {
      LABEL: 'Idioma *',
      PLACEHOLDER: 'Selecciona un idioma...',
      SEARCH_PLACEHOLDER: 'Buscar idiomas...',
      EMPTY_TEXT: 'No se encontró ningún idioma.',
    },
    STANDARDS: {
      LABEL: 'Estándares',
      PLACEHOLDER: 'Selecciona estándares...',
      SEARCH_PLACEHOLDER: 'Buscar estándares...',
      EMPTY_TEXT: 'No se encontró ningún estándar.',
    },
    LOGO: {
      LABEL: 'Logo (opcional)',
      PREVIEW_ALT: 'Vista previa del logo de la organización',
      REMOVE: 'Eliminar',
    },
  },
  ERRORS: {
    NAME_REQUIRED: 'El nombre es obligatorio',
    LANGUAGE_REQUIRED: 'El idioma es obligatorio',
  },
  LANGUAGES: {
    en: 'Inglés',
    es: 'Español',
  },
}
export const COCKPIT = {
  CREATE_ORGANIZATION_DRAWER,
}
